module.exports = __webpack_public_path__ + "static/media/nourish.ec0f959d.png";